import React from 'react';
import './Copies.scss';
import img1 from '../../assets/copy1Img.jpg';
//unused import needed to fix error of old react version compatibility

function Copy1() {
  return (
    <>
      <section className="copies copy1">
        <p className="copies__copy">
          Daniel Boey has been referred to as the “Godfather of Singapore fashion.” As a creative
          and fashion director/curator, he is among the most sought-after in Asia—synonymous with
          inspired, cutting-edge designs. He travels the world, makes numerous TV appearances, and
          generally seems to have it all. But underneath his fashionable attire lies a skin
          condition he has had nearly his whole life: atopic dermatitis (AD), also known as eczema.
          Living with eczema has introduced challenges to his life, including the psychological and
          emotional scars of a long road to feeling confident in his own skin.
        </p>
        <div className="inlinePhoto inlinePhoto--desktop">
          <img className="inlinePhoto__image" src={img1} alt="Portrait of Dr. Zakiya Rice" />
          {/* <p className="inlinePhoto__name inlinePhoto--description">Dr. Zakiya Rice</p> */}
          <p className="inlinePhoto__title inlinePhoto--description">
            Daniel Boey, Fashion Director, TV Personality & Author
          </p>
        </div>
        <p className="copies__copy">
          “It’s taken me decades to reach this [point in my] journey,” Boey says. “I’ve canceled
          jobs, skipped social events—countless weddings of my best friends—just because I felt that
          I wasn’t ready to face the world with red and flaking skin. And that was the kind of life
          I led.”
        </p>
        <p className="copies__copy" style={{ margin: 0 }}>
          People with eczema might recognize or share these sentiments because they understand that
          the impact of this condition goes far beyond its physical symptoms. Sleep disruptions,
          feelings of anxiousness, self-consciousness, and stress are all burdens that many eczema
          patients regularly face in their daily lives. The resulting emotional state can be
          isolating—impacting work, everyday activities, and even self-worth.
        </p>
      </section>
    </>
  );
}

export default Copy1;
